import { css } from 'aphrodite';
import { createHashHistory } from 'history';
import * as React from 'react';
// tslint:disable-next-line:no-submodule-imports
import { hot } from 'react-hot-loader/root';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { IntercomLauncher } from '../../components/IntercomLauncher';
import { InitIntercomService } from '../../models/IntercomService';
import { About } from '../About';
import { Features } from '../Features';
import { Home } from '../Home';
import { HawkSoftPressRelease } from '../PressReleases/HawkSoft';
import { Pricing } from '../Pricing';
import { Privacy } from '../Privacy';
import AppPrivacy from '../Privacy/AppPrivacy';
import { VulnerabilityDisclosure } from '../Privacy/VulnerabilityDisclosure';
import { Terms } from '../Terms';
import { Trial } from '../Trial';
import { TrialHawksoft } from '../TrialHawksoft';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

const HashHistory = createHashHistory();

class AppRouter extends React.Component<IProps> {
	public componentDidMount() {
		InitIntercomService(HashHistory);
	}

	public render() {
		const { className } = this.props;
		return (
			<div className={ `${ css(styleSheet.root) } ${ className || '' }` }>
				<Router history={ HashHistory }>
					<Switch>
						<Route path='/home' component={ Home } />
						<Route path='/features' component={ Features } />
						<Route path='/pricing' component={ Pricing } />
						<Route path='/about' component={ About } />
						<Route path='/privacy' component={ Privacy } />
						<Route path='/privacy-app' component={ AppPrivacy } />
						<Route path='/terms' component={ Terms } />
						<Route path='/try/demo-signup' component={ Trial } />
						<Route path='/try/hawksoft' component={ TrialHawksoft } />
						<Route path='/vulnerability-disclosure' component={ VulnerabilityDisclosure } />
						<Route path='/press-releases/hawksoft' component={ HawkSoftPressRelease } />
						<Redirect to='/home' />
					</Switch>
				</Router>
				<IntercomLauncher />
			</div>
		);
	}
}

// tslint:disable-next-line: no-default-export
export default hot(AppRouter);
